import React from 'preact';

export default props => (
  <div class="footer">
    <span>&copy; Gen Edwards 2015 - 2018</span>
  </div>
);



// WEBPACK FOOTER //
// ./client/components/Footer.jsx